// src/components/layout/Navbar/NavbarWrapper.tsx
import React from "react";
import NavbarUi from "./NavbarUi";

const NavbarWrapper: React.FC = () => {
  return <NavbarUi />;
};

export default NavbarWrapper;
